import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import apiClient from '@/services/axios'
import ViewscreenService from '@/services/api/apiViewscreenService'

Vue.use(Vuex)

const getDefaultState = () => ({
  form: {
    name: '',
    segments: [],
    period: {
      start: null,
      end: null,
    },
    apps: [],
  },
  isFormFilled: false,
  segments: [],
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_FORM(state, form) {
      state.form = { ...form }
    },
    SET_FORM_FIELD(state, { field, value }) {
      state.form[field] = value
    },
    SET_PERIOD_FIELD(state, { field, value }) {
      state.form.period[field] = value
    },
    SET_SEGMENTS(state, segments) {
      state.segments = segments
    },
    ADD_SEGMENT(state, segment) {
      state.segments.unshift(segment)
    },
    SET_IS_FORM_FILLED(state, value) {
      state.isFormFilled = value
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    fillForm({ commit }, data) {
      if (!data) return

      commit('SET_FORM_FIELD', { field: 'name', value: data.name })
      commit('SET_FORM_FIELD', {
        field: 'segments',
        value: data.segments.map((s) => s.id),
      })
      commit('SET_PERIOD_FIELD', {
        field: 'start',
        value: moment.utc(data.period.starts_at),
      })
      commit('SET_PERIOD_FIELD', {
        field: 'end',
        value: moment.utc(data.period.ends_at),
      })
      commit('SET_FORM_FIELD', {
        field: 'apps',
        value: JSON.parse(JSON.stringify(data.applications)),
      })

      commit('SET_IS_FORM_FILLED', true)
    },
    async fetchSegments({ commit }) {
      const response = await ViewscreenService.getSegmentatorSegments()
      commit('SET_SEGMENTS', response.data?.data || [])
    },
    async submitForm({ state }, { moment, router, notify }) {
      const payload = {
        name: state.form.name,
        applications: JSON.parse(JSON.stringify(state.form.apps)),
        segments: [...state.form.segments],
        is_active: false,
      }

      if (state.form.period.start && state.form.period.end) {
        payload.period = {
          starts_at: moment(state.form.period.start)
            .tz('Etc/UTC')
            .format('YYYY-MM-DD'),
          ends_at: moment(state.form.period.end)
            .tz('Etc/UTC')
            .format('YYYY-MM-DD'),
        }
      }

      try {
        const response = await apiClient.post('/admin/custom-page/', payload)

        // eslint-disable-next-line no-throw-literal
        if (response?.status !== 200) throw { response }

        const pageID = response.data?.data?.uuid
        router.push(`/custom-pages/constructor/${pageID}`)
      } catch (e) {
        this.$notification.error({
          message: 'Error while fetching sports',
          description: e.message,
        })
      }
    },
  },
  getters: {
    form: (state) => state.form,
    segments: (state) => state.segments,
    isFormFilled: (state) => state.isFormFilled,
  },
}
